<template>
  <div id="contact">
    <div class="header">
      <div class="contact__img-wrap">
        <picture>
          <img class="Picture" :src="Yamnii_logo_ENG_New">
        </picture>
      </div>
    </div>
    <div class="contact__paragraph">
      <p>
        <span class="number">
          <img alt="Picture" :src="Path_12406"> Government Building 2, United Nation’s street 5/2 Chingeltei district, Ulaanbaatar
        </span>
      </p>

      <p>
        <span class="number">
          <img alt="Picture" :src="Path_13519">
        </span>(976-51) 261966
      </p>
      <p>
        <span class="number">
          <img alt="Picture" :src="Path_13520">
        </span> www.mne.mn
      </p>
    </div>

    <div class="contact">
      <div class="box-contact">
        <form @submit.prevent="onSubmit">
          <input
            type="text"
            v-model="form.name"
            class="form-control"
            placeholder="Your name"
            required
          >
          <br>
          <input
            type="email"
            v-model="form.email"
            class="form-control"
            id="exampleInputEmail1"
            placeholder="Enter email"
            required
          >
          <br>
          <textarea
            v-model="form.message"
            class="form-control"
            rows="5"
            placeholder="Your message to us"
            required
          ></textarea>
          <br>
          <input type="submit" value="SEND" class="btn btn-danger btn-block">
        </form>
      </div>
    </div>

    <div class="mongolia">
      <hr style="margin-top:10%;width:90%;">
      <p class="title text-center">Partner</p>
      <div class="snapshots text-center">
        <img alt="Picture" :src="Union_620">
      </div>
    </div>
  </div>
</template>
<script>
import Yamnii_logo_ENG_New from "@/assets/img/contact/Yamnii logo ENG New.svg";
import Path_12406 from "@/assets/img/contact/Path 12406.png";
import Path_13519 from "@/assets/img/contact/Path 13519.png";
import Path_13520 from "@/assets/img/contact/Path 13520.png";
import Union_620 from "@/assets/img/contact/Union 620.svg";
import axios from "axios";

export default {
  name: "Contact",
  data() {
    return {
      Yamnii_logo_ENG_New,
      Path_12406,
      Path_13519,
      Path_13520,
      Union_620,
      form: {
        name: "",
        email: "",
        message: ""
      }
    };
  },
  methods: {
    onSubmit() {
      axios
        .post("/.netlify/functions/sendmail", this.form)
        .then(() => {
          this.$toasted.show("Thank you, your message has been sent.", {
            type: "success",
            position: "bottom-center",
            duration: 1000
          });

          this.form.name = "";
          this.form.email = "";
          this.form.message = "";
        })
        .catch(err => {
          console.error(err);
          this.$toasted.show("Something went wrong.", {
            type: "error",
            position: "bottom-center",
            duration: 1000
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
#contact {
  padding-top: 52px;
  .header {
    text-align: center;
    align-items: center;
    position: relative;
    .Picture {
      width: 100%;
    }
  }
  .contact__paragraph {
    width: 300.1px;
    align-items: center;
    padding-left: 14px;
    margin: 50px auto 0;
    position: relative;
  }
  .description {
    font-size: 13px;
    align-items: center;
    padding-left: 10px;
    margin: 0 50px 0;
    margin-top: 100px;
  }
  .contact {
    .box-contact {
      padding-left: 10px;
      margin: 50px 50px 0;
    }
  }
  .mongolia {
    .title {
      font-size: 25px;
      color: #000000;
    }
  }
}
</style>

